import { IonButtons, IonMenuButton, IonCard, IonCardContent, IonContent, IonHeader, IonItem, IonLabel, IonPage, IonTitle, IonToolbar,  IonChip, useIonRouter, IonIcon, IonFab, IonFabButton, IonSkeletonText, IonSpinner, IonRefresher, IonRefresherContent, RefresherEventDetail, IonBadge, IonImg, useIonViewDidEnter, IonNote, IonCardHeader, IonCardTitle, IonCardSubtitle, IonBackButton, IonButton, IonCol, IonGrid, IonRow, IonAccordion, IonAccordionGroup, useIonViewWillEnter } from '@ionic/react';
import { add, addCircleOutline, addOutline, alarmOutline, alertCircleOutline, at, atOutline, checkmarkCircleOutline, hourglassOutline, informationCircle } from 'ionicons/icons';
import React, { useEffect, useState } from 'react';
import InitialsAvatar from 'react-initials-avatar';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import { Link } from 'react-router-dom';
import { useAppContext } from '../AppProvider';
import Alert from '@mui/material/Alert';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { AlertTitle } from '@mui/material';

const Contacts: React.FC = () => {
    const [loading, setLoading] = useState<boolean>(true);
    const [alertVisible, setAlertVisible] = useState<boolean>(false);
    const router = useIonRouter();
    const { networkStatus, getAppStatus, authKey, authenticateMember, authorizedMember, setShowLoader, limits, profiles, settings, contacts, getContacts, textLogoLoaded, fadeInTextLogo, SWTextLogo, SWFullHorizLogo, SWTextDarkLogo } = useAppContext();
      
    //
    // Authenticate Member
    //
    useIonViewWillEnter(() => { 
        setShowLoader(true);
        const authenticate = async () => {
            const appstat = await getAppStatus();
            if (!networkStatus && appstat === 'No') {
                router.push('/connection', 'forward');
            } else {
                const authenticated = await authenticateMember();   
                if(!authenticated || authenticated.mt == '') router.push('/login', 'forward');
            }
        };
        authenticate();
    }); 


    useEffect(() => {
        if (limits.contacts > 0) {
            const fetchData = async () => {
                await getContacts(authorizedMember.memberToken, 'all', limits.contacts);
                setLoading(false);
                window.setTimeout(() => {
                    setShowLoader(false);
                }, 2000);
            }
            fetchData();
        }
    }, [authorizedMember, limits]);


    const statusChip = (s: string) => {
            switch(s) {
                case '0': return <IonChip slot='end' color={'medium'}><IonIcon icon={hourglassOutline}></IonIcon><IonLabel>Pending</IonLabel></IonChip>
                case '1': return <IonChip slot='end' color={'medium'}><IonIcon icon={hourglassOutline}></IonIcon><IonLabel>Pending</IonLabel></IonChip>
                case '2': return <IonChip slot='end' color={'success'}><IonIcon icon={checkmarkCircleOutline}></IonIcon><IonLabel>Confirmed</IonLabel></IonChip>
                case '3': return <IonChip slot='end' color={'danger'}><IonIcon icon={alertCircleOutline}></IonIcon><IonLabel>Request Bounced</IonLabel></IonChip>
                default:  return <IonChip slot='end' color={'light'}><IonLabel>Unknown</IonLabel></IonChip>
            }
        };

    const handleRefresh = (event: CustomEvent<RefresherEventDetail>) => {
        //setLoading(true);
        setTimeout(() => {
          getContacts(authKey.mt, 'all', limits.contacts);
          event.detail.complete();
          //setLoading(false);
        }, 2000);
    };

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot='start'>
                        <IonBackButton color={'tertiary'}>Back</IonBackButton>
                    </IonButtons>
                    <IonTitle><IonImg className={textLogoLoaded ? 'fade-in' : 'fade-out'} src={settings.theme == '1' ? SWTextDarkLogo : SWFullHorizLogo} onIonImgDidLoad={fadeInTextLogo}></IonImg></IonTitle>
                    <IonButtons slot='end'>
                        <IonMenuButton color={'tertiary'} />
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding account-content-bg" id="Contacts" fullscreen>
                
                <IonRefresher slot="fixed" onIonRefresh={handleRefresh}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>

                <IonGrid>
                    <IonRow>
                        <IonCol size='12' sizeSm='7'>
                            <h1><IonIcon color={'secondary'} icon={at}></IonIcon> My Contacts<br /><span>Manage your emergency contacts</span></h1>
                        </IonCol>
                        <IonCol className='ion-margin-bottom top-action-button'  size='12' sizeSm='5'>                            
                             {!loading && profiles?.contacts < limits?.contacts &&                    
                                <IonButton className='ion-margin' color={'secondary'} routerLink='/account/contact/create' routerDirection='forward'><IonIcon icon={addCircleOutline} slot='start'></IonIcon> Add a New Contact</IonButton>
                            }
                        </IonCol>
                    </IonRow>
                </IonGrid>

                <IonAccordionGroup className='ion-margin'>
                    <IonAccordion value="info">
                        <IonItem slot='header' color={'light'}>
                            <IonLabel><IonIcon color={'tertiary'} icon={informationCircle} size='large'></IonIcon> What is a SoloWise Contact?</IonLabel>
                        </IonItem>
                        <div slot="content">                
                            <IonCard>
                                <IonCardContent>
                                    <p>A <strong>SoloWise Contact</strong> must be someone whom you know and trust to forward critical information to the proper authorities during an emergency situation. You will need to enter the name and email address for each SoloWise Contact you register. You must create at least one Contact before you can set a Timer.</p>
                                </IonCardContent>
                            </IonCard>
                        </div>
                    </IonAccordion>
                </IonAccordionGroup>

                {contacts.length > 0
                    ? <>
                        {contacts.map((contact:any, index:any) => (                    
                        <IonCard key={index} routerLink={`/account/contact/edit/${contact.contactToken}`}>
                            <IonCardHeader>
                                {loading 
                                    ? (<>
                                        <IonCardTitle><IonSkeletonText animated={true} style={{ width: '50%' }}></IonSkeletonText></IonCardTitle>
                                        <IonCardSubtitle><IonSkeletonText animated={true} style={{ width: '75%' }}></IonSkeletonText></IonCardSubtitle>
                                        </>)
                                    : (<>
                                        <IonCardTitle>{contact.contactLastName}, {contact.contactFirstName}</IonCardTitle>
                                        <IonCardSubtitle>{contact.contactEmail}</IonCardSubtitle>
                                        </>)
                                }
                            </IonCardHeader>
                            <IonCardContent>
                                {!loading && statusChip(contact.contactStatus)}
                                {contact.contactStatus == '1' &&
                                    <div>
                                        <IonNote color={'warning'}><em>If your contact does not see the request email in their Inbox, ask them to check their Junk/Spam box.</em></IonNote>
                                    </div>
                                }
                                {contact.contactStatus == '3' &&
                                    <div>
                                        <IonNote color={'danger'}><em>Please double-check the validity of this email address.</em></IonNote>
                                    </div>
                                }
                            </IonCardContent>
                        </IonCard>
                        ))} 
                        {profiles?.contacts >= limits?.contacts &&
                            <IonCard>
                                <IonCardHeader>
                                    <IonCardTitle className='ion-margin-bottom ion-text-center' color={'tertiary'}>
                                        You've reached the limit of Contacts for your current plan.
                                    </IonCardTitle>
                                </IonCardHeader>
                                <IonCardContent>
                                    <p className='ion-margin-bottom ion-text-center'>
                                        You can add more Contacts by upgrading to a SoloWise Premium plan. 
                                    </p>
                                    <p className='ion-margin-bottom ion-text-center'>                            
                                        <IonButton className='ion-margin' color={'secondary'} routerLink='/account/plans' routerDirection='forward'><IonIcon icon={addCircleOutline} slot='start'></IonIcon> Upgrade Now</IonButton>
                                    </p>
                                </IonCardContent>
                            </IonCard>
                        }                     
                      </>

                    : (loading
                          ? <p className='ion-text-center'>Loading<br /><IonSpinner className='ion-margin-top' name="crescent"></IonSpinner></p>
                          : <p className='ion-text-center'>You have no recorded SoloWise Contacts.</p>
                        )
                }
            </IonContent>
        </IonPage>
    );
};

export default Contacts;
